import { Node, Schema } from 'prosemirror-model'
import { schema as neruda, StrongNode } from 'prose-core'
import { StrongNodeSpec } from 'prose-core'

export const prepareNodes = (elements: any[], schema: Schema = neruda): StrongNode<StrongNodeSpec>[] => {
  return elements.map((node) => {
    return Node.fromJSON(schema, node.data_json)
  })
}

export const docFromDataJson = (dataJsonElements: any[]) => {
  const nodes = dataJsonElements.map((e) => Node.fromJSON(neruda, e.data_json))
  return neruda.nodes.doc.create({}, nodes)
}
